import React, { useState } from "react";

import UserSelectComponent from "../../components/UserSelectComponent";

import { StyledModal, UpdateButton, CloseButton, StyledModalFooter } from "./styles";
import { showErrorNotification } from "../../components/Notification";
import { proxyUser, searchProxyUdyUser } from "../../services/proxyAccountService";


interface ProxyAccountModalProps {
	modalTitle: string;
	isModalOpen: boolean;
	handleOk: () => void;
	handleCancel: () => void;
}

interface User {
	id: string;
	fullName: string;
	email: string;
}

const SELECT_STYLE = { width: "100%", height: "40px", marginBottom: "23px" };

const ProxyAccountModal: React.FC<ProxyAccountModalProps> = ({
	modalTitle,
	isModalOpen,
	handleOk,
	handleCancel,
}) => {
	const [searchText, setSearchText] = useState<string>("");
	const [loading, setLoading] = useState<boolean>(false);
	const [searchingUser, setSearchingUser] = useState<boolean>(false);
	const [searchResult, setSearchResult] = useState<User[]>([]);
	const [selectedUser, setSelectedUser] = useState<User | null>(null);

	const handleSearchUser = async (value: string) => {
		if (value.length >= 2) {
			setSearchingUser(true);
			setSearchText(value);
			try {
				const users = await searchProxyUdyUser(value);
				setSearchResult(users);
			} catch (error) {
				console.error("Kullanıcı arama hatası:", error);
			} finally {
				setSearchingUser(false);
			}
		}
	};

	const handleSelectChangeUser = (value: string) => {
		const person = searchResult.find((p) => p.id === value);
		setSelectedUser(person || null);
	};

	const handleCancelClick = async () => {
		handleCancel();
		setSelectedUser(null);
		setSearchText("");
		setSearchResult([]);
		setSearchingUser(false);
		setLoading(false);
	};

	const handleSaveClick = async () => {
		if (selectedUser) {
			setLoading(true);
			await proxyUser(selectedUser?.id);
			handleOk();
			setSelectedUser(null);
			setSearchText("");
			setSearchResult([]);
			setSearchingUser(false);
			setLoading(false);

		} else {
			showErrorNotification("Geçersiz Kullanıcı Bilgileri");
		}
	};

	return (
		<StyledModal
			title={"Hesap Değiştir"}
			open={isModalOpen}
			onOk={handleOk}
			onCancel={handleCancelClick}
			width={343.5}
			footer={false}
		>
			<UserSelectComponent
				title="Kişi Ara"
				isRequired
				selectedUser={selectedUser}
				searchText={searchText}
				searchingUser={searchingUser}
				searchResult={searchResult}
				onSelectUser={handleSelectChangeUser}
				onSearchUser={handleSearchUser}
				style={SELECT_STYLE}
			/>

			<div>
				E-Onay uygulaması kullanıcıları içerisinde yer almayan Yönetici olmayan kişiler, arama listesinde bulunmamaktadır.
			</div>

			<StyledModalFooter>
				<CloseButton type="primary" onClick={handleCancelClick}>
					Vazgeç
				</CloseButton>
				<UpdateButton type="primary" loading={loading} disabled={!selectedUser} onClick={handleSaveClick}>
					Değiştir
				</UpdateButton>
			</StyledModalFooter>

		</StyledModal>
	);
};

export default ProxyAccountModal;
